"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var _1 = require("./");
var ApiCoverageDetail = (function (_super) {
    __extends(ApiCoverageDetail, _super);
    function ApiCoverageDetail() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ApiCoverageDetail;
}(_1.ApiCoverage));
exports.ApiCoverageDetail = ApiCoverageDetail;
//# sourceMappingURL=D:/a/1/s/base/src/models/api-coverage-detail.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/base/src/models/api-coverage-detail.model.js